import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

export const StyledContainer = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
  };
});

export const StyledLine = styled('div')(() => {
  return {
    background: COLORS.primary,
    height: 1,
    width: '12px',
    display: 'flex',
    alignItems: 'center',
  };
});
